import { render, staticRenderFns } from "./cuentasPorCobrar.vue?vue&type=template&id=78ff852b&"
import script from "./cuentasPorCobrar.vue?vue&type=script&lang=js&"
export * from "./cuentasPorCobrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports